import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import MerchantFileFormHandle from '../containers/forms/merchant/merchantFile/MerchantFileFormHandle';
import MerchantListFormHandle from '../containers/forms/merchant/merchantList/MerchantListFormHandle';
import MerchantPerCityFormHandle from '../containers/forms/merchant/merchantPerCity/MerchantPerCityFormHandle';
import MerchantPerActivityFormHandle from '../containers/forms/merchant/merchantPerActivity/MerchantPerActivityFormHandle';


const Merchant = () => {
  return (
    <div>
      <CC.Box>
        <CC.Text fontSize={20} fontWeight="bold" mb="4">
        Commerçant
        </CC.Text>
        <CC.Tabs>
          <div style={{overflowX: "auto"}}>
          <CC.TabList>
            <CC.Tab minWidth={'fit-content'}>Fichier commerçant</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Liste commerçants</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Commerçant par ville</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Commerçant par activité</CC.Tab>
          </CC.TabList>
          </div>

          <CC.TabPanels>
            <CC.TabPanel>
              <MerchantFileFormHandle />
            </CC.TabPanel>
            <CC.TabPanel>
              <MerchantListFormHandle />
            </CC.TabPanel>
            <CC.TabPanel>
              <MerchantPerCityFormHandle />
            </CC.TabPanel>
            <CC.TabPanel>
              <MerchantPerActivityFormHandle />
            </CC.TabPanel>
          </CC.TabPanels>
        </CC.Tabs>
      </CC.Box>

    </div>
  )
}

export default Merchant;